import type { Linter } from 'eslint'

export const reactNativeRules: Linter.RulesRecord = {
  'global-require': 'off',
  'react-native/no-inline-styles': 'off'
}
